import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Api from "../../Api";
import RentReceiptDisplay from "../../parts/RentReceipt";
import { Company, RentContract, RentReceipt } from "../../types";

const ExternalRentReceipt = () => {
  const { hash } = useParams();
  const [receipt, setReceipt] = useState<RentReceipt | null>(null);
  const [contract, setContract] = useState<RentContract | null>(null);
  const [company, setCompany] = useState<Company | null>(null);

  useEffect(() => {
    Api.externalGetRentReceipt(hash!).then(({ receipt, contract, company }) => {
      setReceipt(receipt);
      setContract(contract);
      setCompany(company);
    });
  }, [hash]);

  return (
    <div>
      {receipt !== null && contract !== null && company !== null && (
        <RentReceiptDisplay
          receipt={receipt}
          contract={contract}
          company={company}
        />
      )}
    </div>
  );
};

export default ExternalRentReceipt;
